import { data } from '../../svg/Journey/data';
import { makeIcon } from '../makeIcon';

export const Journey = makeIcon(data, 'journey', 'Journey');

export default Journey;
